<template>
<div>
    <div id="worksends-page-header" class="tw-mb-3">
        <div class="breadcrumbs" id="breadcrumbs">
          <router-link class="breadcrumb-link" to="/campaigns/">All Bookblock HUB Campaigns</router-link>
        </div>
        <h3>Bookblock HUB Campaigns <span class="preview" v-if="team.plan!='pro'">PREVIEW</span></h3>
        <div class="ws-button ws-button-main" @click="requestNewCampaign">Request New Campaign</div>
    </div>
    <notification type="gift_registrations"></notification>
    <div v-if="team.plan!='pro'" class="note"><span>Campaigns Preview:</span> You are viewing a demo preview of various <b>Bookblock HUB Pro</b> campaign types. This is how your campaigns page can look after you upgrade to <b>Bookblock HUB Pro</b>.</div>
    <div id="list-of-campaigns">
        <div class="campaign" v-for="item in index.data" @click="goToDetailPage(item.id)" :key="item.id" :class="item.reward_type+'-campaign'">
            <div class="campaign-image"><div class="campaign-image-inner" :style="'background-image: url('+getCampaignImage(item)+')'"></div></div>
            <div class="campaign-name">{{ item.name }}</div>
            <div class="campaign-status" :class="item.status" >{{ item.status }}</div>
            <div class="campaign-subtitle">{{ item.type }} campaign</div>

            <div class="campaign-page-stats">
                <div class="campaign-page-stat" data-stat="sends">
                    <div class="stat-number">{{ item.analytics.sends }}</div>
                    <div class="stat-label">Invites</div>
                </div>
                <div class="campaign-page-stat" data-stat="confirmed">
                    <div class="stat-number">{{ item.analytics.confirmed }}</div>
                    <div class="stat-label">
                        <span v-if="item.type=='reviews'">Reviews</span>
                        <span v-else-if="item.type=='sales'">Redeems</span>
                        <span v-else>Claims</span>
                    </div>
                </div>
                <div class="campaign-page-stat" data-stat="total-spent_ev">
                    <div class="stat-number">{{ item.analytics.spent_ev | toCurrency }}</div>
                    <div class="stat-label">Total Spent</div>
                </div>
            </div>

            <div class="campaign-actions">
                <router-link class="ws-button small ws-button-main" :to="'/campaigns/' + item.id" @click.prevent>VIEW CAMPAIGN</router-link>
                <a class="ws-button small ws-button-inverted" :href="item.registration_page" @click="donotfollow = true" target="_blank">
                    <span v-if="item.type=='reviews'">REVIEW PAGE</span>
                    <span v-else>CLAIM PAGE</span>
                </a>
            </div>
        </div>
    </div>
    <ws-table-meta v-if="index.data.length" :meta="index.meta" sum="You have % gifting campaigns."></ws-table-meta>

    <div v-if="!$wait.any && !demo.isDemo && team.plan=='pro'" id="internal-ad-campaigns-listing" class="internal-ad internal-ad-block">
        <div class="internal-ad-body">
            <h2>Create Awesome Campaigns</h2>
            <p>Looking to create a new campaign? Gift them something they'll really love. Browse our full range of gifts and get inspired...</p>
            <a class="ws-button ws-button-primary" href="/corporate-giftsets" target="_blank">Browse Now</a>
        </div>
    </div>

    <gift-box-campaigns-edit-modal v-if="modals.editGiftBoxCampaign" @created="onCampaignCreated" type="create" tab="campaign"></gift-box-campaigns-edit-modal>
</div>
</template>

<script>
import GiftBoxCampaignsEditModal from '@/pages/gift-box-campaigns/GiftBoxCampaignsEditModal';

export default {
    name: "GiftBoxCampaignsIndex",
    components: {GiftBoxCampaignsEditModal},
    data: () => ({
        pageParams: {
            pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 50},
            search: {val: ""},
            filters: {},
        },
        donotfollow: false
    }),
    methods: {
        async getPage(params) {
            await this.getPageHandler({
                waitName: 'gb_campaigns.index',
                action: 'fetchGiftBoxCampaigns', // vuex action
                pageParams: this.pageParams,
                isInit: params ? params.init : false, // parse from url query params
                pushRoute: true, // push pagination params and search q to route
                resetPagination: params ? params.resetPagination : false, // new search input -> need to reset page & sorting
            });
        },
        requestNewCampaign() {
            if (!this.proCheck('Requesting custom campaigns')) return; 
            this.modals.editGiftBoxCampaign = true;
        },
        onCampaignCreated() {

        },
        goToDetailPage(id) {
            if (this.donotfollow) this.donotfollow = false;
            else this.$router.push({name:'campaign-detail', params: {id}});
        },
        getCampaignImage(item) {
          if (!item.options || item.options.length == 0) return '';
          let option = item.options[0];
          if (option.image_url) return option.image_url;
          else return '';
        },
        async fetchData() {
            await this.dispatchWaitAndNotify('fetchTeam', null, false, true);
        },
        gbPageUrl(teamSlug, campaignSlug) {
            return `/${this.gbPageUrlBase}/${teamSlug}/${campaignSlug}`;
        }
    },
    async mounted() {
        this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name);
		await this.fetchData();
		this.getPage({init:true});
	},
    computed: {
        index() {
            return this.$store.state.giftBoxCampaign.index;
        },
        team() {
            return this.$store.state.team.detail;
        },
        gbPageUrlBase() {
            return this.$store.state.gbPageUrlBase;
        },
        privacyLevels() {
			return this.$store.state.privacyLevels;
		},
        modals() {
			return this.$store.state.modals;
		},
        demo() {
            return this.$store.state.demo;
        },

    },
    watch: {
        // 'pageParams.pageOptions': {
        //     handler (newVal, oldVal) {
        //         if (oldVal != null) { // we need to load initial data based on url query instead
        //             this.getPage();
        //         }
        //     },
        //     deep: true,
        // },
    },
}
</script>
